import Pagination from "../../common/reactPaginate";
import { getLabel } from "../../common/getLabel";
import TableSkeleton from "../../common/TableSkeleton";
const Listing = (props) => {
    const {
        seoUrlListing,
        loading,
        error,
        totalCount,
        handlePaginate,
        currentPage,
        limit,
        handleFormShow,
        editUrlRewrite,
    } = props;
    const calculateSerialNumber = (index) =>
        (currentPage - 1) * limit + index + 1;
    const totalPages = Math.ceil(totalCount / limit);
    const handlePageClick = (selectedPage) => {
        handlePaginate(selectedPage);
    };

    return (
        <>
            <form id="faq-listing">
                <table className="table table-striped table-bordered" cellSpacing="0" width="100%">
                    <thead>
                        <tr>
                            <th className="table-id">{getLabel("LBL_Sr._No.")}</th>
                            <th>{getLabel("LBL_Orginal")}</th>
                            <th>{getLabel("LBL_Custom")}</th>
                            {editUrlRewrite && <th>{getLabel("LBL_Action")}</th>}
                        </tr>
                    </thead>
                    <tbody>

                        {loading ? (
                            <>
                                <TableSkeleton cards={limit} count={4} />
                            </>
                        ) : error ? (
                            <tr className="no--record">
                                <td colspan="4" className="text-center">{getLabel("LBL_Some_thing_wrong_Please_try_again_later")}</td>
                            </tr>
                        ) : (
                            <>
                                {seoUrlListing && seoUrlListing.length > 0 ? (
                                    seoUrlListing.map((elem, index) => (
                                        <tr className="actions" key={index}>
                                            <td>{calculateSerialNumber(index)}</td>
                                            <td>
                                                <div className="verified-wrap">
                                                    <span className="user-profile_title">
                                                        {elem["urlrewrite_original"]}
                                                    </span>
                                                </div>
                                            </td>
                                            <td>{elem["urlrewrite_custom"]}</td>
                                            {editUrlRewrite && (
                                                <td>
                                                    <span className="action">
                                                        <ul>
                                                            <li>
                                                                <a>
                                                                    <i
                                                                        className="bx bx-pencil"
                                                                        onClick={() =>
                                                                            handleFormShow(elem["urlrewrite_id"])
                                                                        }
                                                                    ></i>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </span>
                                                </td>
                                            )}
                                        </tr>
                                    ))
                                ) : (
                                    <tr className="no--record">
                                        <td colspan="4" className="text-center">{getLabel("LBL_No_result_found")}</td>
                                    </tr>
                                )}
                            </>
                        )}
                    </tbody>
                </table>
            </form>
            {seoUrlListing && seoUrlListing.length > 0 && (
                <Pagination totalPages={totalPages} handlePageClick={handlePageClick} currentPage={currentPage} />
            )}
        </>
    );
};

export default Listing;
